import type { HttpClient } from '@core/model/framework/httpClient';
import { Result } from '@core/model/framework/Result/Result';
import {
  AbortCaseServiceInput,
  AbortCaseServiceOutput,
  ClerkService,
  FailCaseServiceInput,
  FailCaseServiceOutput,
} from '@core/model/service/clerkService';
import { SERVICE_ID } from '@di/serviceId';
import { inject, injectable } from 'inversify';

@injectable()
export class DFClerkService implements ClerkService {
  constructor(
    @inject(SERVICE_ID.openBankingHttpClient)
    private readonly httpClient: HttpClient
  ) {}

  async abortCase(input: AbortCaseServiceInput): AbortCaseServiceOutput {
    const { userToken, userId } = input;
    const result = await this.httpClient.post<undefined, undefined>(
      `/users/${userId}/open-banking-case-clerk/abort`,
      undefined,
      {
        Authorization: `Bearer ${userToken}`,
      }
    );

    Result.unwrap(result);
  }

  async failCase(input: FailCaseServiceInput): FailCaseServiceOutput {
    const { userToken, userId } = input;
    const result = await this.httpClient.post<undefined, undefined>(
      `/users/${userId}/open-banking-case-clerk/fail`,
      undefined,
      {
        Authorization: `Bearer ${userToken}`,
      }
    );

    Result.unwrap(result);
  }
}
